const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const sendMessage = async (messages, templateInfo = '') => {
  const response = await fetch(`${BASE_URL}/api/chat`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ messages, templateInfo }),
  });
  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.error || 'Failed to send message');
  } 
  return response.json();
};

export const saveResume = async (userId, resume) => {
  const response = await fetch(`${BASE_URL}/api/resume/save`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userId, resume }),
  });
  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.error || 'Failed to save resume');
  }
  return response.json();
};

export const loadResumes = async (userId) => {
  const response = await fetch(`${BASE_URL}/api/resume/${userId}`);
  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.error || 'Failed to load resumes');
  }
  return response.json();
};

export const deleteResume = async (userId, resumeId) => {
  const response = await fetch(`${BASE_URL}/api/resume/${userId}/${resumeId}`, { method: 'DELETE' });
  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.error || 'Failed to delete resume');
  }
  return response.json();
};

// Download resume as PDF with selected template
export const downloadPDF = async (resume, templateId = 1, photo = null) => {
  const response = await fetch(`${BASE_URL}/api/pdf/generate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ resume, templateId, photo }),
  });
  if (!response.ok) throw new Error('Failed to generate PDF');
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${(resume.name || 'resume').replace(/\s+/g, '_')}_resume.pdf`;
  a.click();
  window.URL.revokeObjectURL(url);
};
